// libraries
import React from 'react'
import clsx from 'clsx'
import MacroQuote from '../MacroQuote'

// interface
export interface Props {
    content?: string
    className?: string
}

export default function RichText({
    content,
    className
}: Props) {
    return (
        <>
        <div
            className={clsx('rich-text', className)}
            dangerouslySetInnerHTML={{ __html: content }}
            suppressHydrationWarning
        />
       
    </>
    )
}